import { Image } from '@gyym/ui'
import type { ImageProps } from 'next/image'

import { CoverContainer } from './styles'

export interface CoverImageProps {
  src: ImageProps['src']
  alt: ImageProps['alt']
  objectPosition?: string | number
}

export const CoverImage = ({
  src,
  alt,
  objectPosition = 'center',
}: CoverImageProps) => (
  <CoverContainer>
    <Image
      src={src}
      alt={alt}
      fill
      style={{
        objectFit: 'cover',
        objectPosition,
      }}
      priority
    />
  </CoverContainer>
)
